import { useEffect } from "react";

export default function UndoToast({ message, onUndo, onClose }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 5000); // ⏱ auto dismiss

    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div
      className="
        fixed bottom-6 left-1/2 -translate-x-1/2
        flex items-center gap-4
        bg-black text-white
        px-4 py-2.5
        rounded-lg
        shadow-lg
        z-50
        text-sm
      "
    >
      <span className="opacity-90">{message}</span>

      <button
        onClick={onUndo}
        className="font-medium underline hover:opacity-80"
      >
        Undo
      </button>
    </div>
  );
}
